export default {
  baseDevURL: 'http://localhost:8080',
  baseProURL: 'https://api.treat-assistant.de',
  headers: {
    'X-Parse-Application-Id': 'AT_POPApp',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  },
  timeOut: 30000,
};
